export enum ERoutePaths {
  Root = '/',
  Login = '/login',
  Register = '/register',
  ForgotPassword = '/forgot-password',
  NewPassword = '/new-password',
  Home = '/home',
  Dashboard = '/dashboard',
  Orders = '/orders',
  Products = '/my-products',
  ProductPreview = '/product-preview/:id',
  Payments = '/payments',
  Messages = '/messages',
  Settings = '/settings',
  ShopifyCallback = '/shopify_callback',
  ShopifyInstallAppPath = '/install_app',
}

export enum ERouteNames {
  Login = 'Login',
  Register = 'Register',
  ForgotPassword = 'Forgot Password',
  NewPassword = 'New Password',
  Home = 'Home',
  Dashboard = 'Dashboard',
  Orders = 'Orders',
  Products = 'My Products',
  ProductPreview = 'Product Preview',
  Payments = 'Payments',
  Messages = 'Messages',
  Settings = 'Settings'
}
